import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getHeatmapActivityResponses = async (activityId) => {
    const { data } = await vlqrApi.get(`/FocusGroupHeatmapActivities/${activityId}/heatmapResponses`)
        .catch((error) => {
            handleError(error);
        });

    // Exclude deleted sentiment/comments
    return data?.filter(x => !x.deletedOn);
};

const getHeatmapActivityResponsesForCrossSessionActivity = async (crossSessionActivityId) => {
    const { data } = await vlqrApi.get(`/FocusGroupHeatmapActivities/crossSession/${crossSessionActivityId}/heatmapResponses`)
        .catch((error) => {
            handleError(error);
        });

    // Exclude deleted sentiment/comments
    return data?.filter(x => !x.deletedOn);
};

const useHeatmapResponsesForActivity = ({ activityId, crossSessionId }) => {
    const queryKey = [crossSessionId
        ? 'heatmapResponsesForCrossSessionActivity'
        : 'heatmapResponsesForActivity'];
    const queryKeyValue = crossSessionId ?? activityId;

    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: [queryKey, queryKeyValue],

        queryFn: () => crossSessionId
            ? getHeatmapActivityResponsesForCrossSessionActivity(crossSessionId)
            : getHeatmapActivityResponses(activityId)
    });

    return { data, refetch, isLoading, isError };
};

export default useHeatmapResponsesForActivity;
